import { useQuery } from '@apollo/client';
import { skyhookClubTiers } from '@website/components/SkyhookClub/LoyaltyRewards';
import { UserDashboardDocument } from '@website/types/graphqlOperations';
import { ParsedUrlQuery } from 'querystring';
import { Col } from 'react-bootstrap';
import { FaHiking } from 'react-icons/fa';
import LoadingPage from '../../utilities/LoadingPage';
import { CustomerDashboardLayout } from './CustomerDashboardLayout';
import styles from './CustomerSkyhookClub.module.scss';

type Props = {
  query: ParsedUrlQuery;
};

export function CustomerSkyhookClub({ query }: Props) {
  const { userID } = query;

  // API calls
  const { loading, data } = useQuery(UserDashboardDocument, {
    variables: { id: userID as string },
    // incase of error, please also return data as well this could be a permissions
    // issue
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  });

  if (loading && !data) {
    return <LoadingPage />;
  }

  const { user } = data;

  const tier =
    skyhookClubTiers.find((t) => t.title === user.skyhookClubTier) ??
    skyhookClubTiers[0];

  return (
    <CustomerDashboardLayout activeTab="Club" userID={userID as string}>
      <h5>Skyhook Club</h5>
      <p>
        Congratulations, {user.givenName}! You're a {tier.title} Member of the
        Skyhook Club. Earn reward credits every time you travel with us. You
        need to complete a trip to move up member tiers.
      </p>

      <div className={styles.clubTiers}>
        <div className={styles.headerRow}>
          <div className={styles.loyaltyTiers}>Loyalty Tier</div>
          <div># of Completed Trips</div>
          <div className={styles.rewards}>Rewards</div>
          <div className={styles.currentTier}>Your Current Tier</div>
        </div>

        {skyhookClubTiers.map((t) => (
          <div className={styles.bodyRow} key={t.title}>
            <div className={styles.loyaltyTiers}>
              <FaHiking
                size={40}
                className="me-1"
                style={{
                  fill: t.color,
                }}
              />

              {t.title}
            </div>
            <div>
              <p>{t.subtitle}</p>
              <p className={styles.showOnMobile}>{t.reward}</p>
            </div>
            <div className={styles.rewards}>{t.reward}</div>
            <div
              className={styles.currentTier}
              style={{
                textAlign: 'center',
              }}
            >
              {t.title === user.skyhookClubTier ? (
                <FaHiking
                  size={40}
                  style={{
                    fill: t.color,
                  }}
                />
              ) : (
                '-'
              )}
            </div>
          </div>
        ))}
      </div>

      <Col xs={12} className="mt-5 small fst-italic text-center">
        * Credits are automatically added to an account after a trip is
        complete, and can be used against the deposit of any future trip.
        Credits never expire but can’t be used against balance payments and are
        non-refundable for cash. They can, however, be transferred to friends
        and family.
      </Col>
    </CustomerDashboardLayout>
  );
}
